export const actions: Actions = {
  start: 'Iniciou atendimento:',
  transfer: 'Transferiu atendimento:',
  finish: 'Finalizou atendimento:',
  unbind: 'Desvinculou do atendimento:'
}
